const useMessageStore = async () =>
  await import('@/stores/message').then((resp) => {
    return resp.useMessageStore()
  })
import Axios from 'axios'
import * as Sentry from '@sentry/vue'

Axios.defaults.baseURL = `${import.meta.env.VITE_API_BASE}/api/v1/`
Axios.defaults.withCredentials = true
Axios.defaults.withXSRFToken = true

Axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const store = await useMessageStore()
    await store.setAlert({
      level: 'error',
      text: error.response.data?.message
    })
    if (error.isAxiosError) {
      Sentry.captureException(error, {
        extra: {
          request: error.config,
          response: error.response
        }
      })
    }
    return Promise.reject(error)
  }
)

export default Axios
